<template>
  <nav class="site-nav">
    <div class="site-nav__inner container px-4">
      <a href="/" class="site-nav__brand" aria-label="AJL Corporate Advisors">
        <img
          src="../assets/logo.png"
          alt="AJL Corporate Advisors"
          class="site-nav__logo"
        />
      </a>
      <ProfileSwitcher
        class="site-nav__switcher"
        :active-profile="activeProfile"
      />
    </div>
  </nav>
</template>

<script>
import ProfileSwitcher from "./ProfileSwitcher.vue";

export default {
  name: "NavBar",
  components: {
    ProfileSwitcher,
  },
  props: {
    activeProfile: {
      type: String,
      required: true,
      validator: (value) => ["andreas", "rasha"].includes(value),
    },
  },
};
</script>

<style scoped>
.site-nav {
  margin-bottom: 0.75rem;
  padding: 0.75rem 0.5rem 0;
}

.site-nav__inner {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  justify-content: center;
}

.site-nav__brand {
  flex-shrink: 0;
  max-width: min(58vw, 220px);
}

.site-nav__logo {
  display: block;
  height: 3rem;
  max-width: 100%;
  object-fit: contain;
  width: auto;
}

.site-nav__switcher {
  flex: 0 1 100%;
  max-width: 100%;
}

@media (min-width: 768px) {
  .site-nav__inner {
    justify-content: space-between;
  }

  .site-nav__brand {
    max-width: none;
  }

  .site-nav__logo {
    height: 4rem;
  }

  .site-nav__switcher {
    flex: 0 0 auto;
    margin-left: auto;
  }
}
</style>
